import {RouteObject} from 'react-router';
import {authGuard} from '@common/auth/guards/auth-route';
import {lazyAdminRoute} from '@common/admin/routes/lazy-admin-route';

export const appAdminRoutes: RouteObject[] = [
  {
    path: 'banners',
    loader: () => authGuard({permission: 'banners.view'}),
    lazy: () => lazyAdminRoute('BannerIndexPage'),
  },
];